<template>
  <div>
    <div>
      <v-form
        v-if="formModel.mainRequest"
        ref="requestFormRef"
      >
        <template v-if="renderOrganizationApplicantDetails">
          <organization-sub-request-applicant
            v-if="requestType.showDefaultRequestApplicantSection && !isInternal"
            :form-model="formModel"
            :is-new-mode="isNewMode"
            :is-view-mode="isViewMode"
            :is-edit-mode="isEditMode"
            :request-type="requestType"
          ></organization-sub-request-applicant>
          <organization-sub-request-applicant-only-name
            v-if="requestType.showOnlyNameRequestApplicantSection || isInternal"
            :form-model="formModel"
            :is-new-mode="isNewMode"
            :is-view-mode="isViewMode"
            :is-edit-mode="isEditMode"
            :request-type="requestType"
          ></organization-sub-request-applicant-only-name>
        </template>
        <template v-else>
          <!-- request applicant -->
          <sub-request-applicant
            v-if="requestType.showDefaultRequestApplicantSection && !isInternal"
            :form-model="formModel"
            :is-new-mode="isNewMode"
            :is-view-mode="isViewMode"
            :is-edit-mode="isEditMode"
            :request-type="requestType"
          ></sub-request-applicant>

          <sub-request-applicant-only-name
            v-if="requestType.showOnlyNameRequestApplicantSection || isInternal"
            :form-model="formModel"
            :is-new-mode="isNewMode"
            :is-view-mode="isViewMode"
            :is-edit-mode="isEditMode"
          ></sub-request-applicant-only-name>
          <!-- request applicant -->
        </template>

        <!-- Request Data Form -->
        <div v-if="requestType.customComponentName">
          <naj-dynamic-form
            :custom-component-name="requestType.customComponentName"
            :required-data="requestCustomData"
            :form-model="formModel"
            :view-mode="isViewMode"
          ></naj-dynamic-form>
        </div>

        <!-- Request Data Form -->

        <div
          v-if="requestType.showRequestReasonSection"
          class="px-3 content-wrapper"
        >
          <h3 class="d-inline-block primary--text font-weight-bold col col-2 mb-4">
            {{ local.bankruptcy.subRequests.requestReasons }}
          </h3>
          <span
            v-if="!isViewMode"
            class="request-reasons-warning"
          >
            <v-icon color="#FAAD14">
              mdi-alert
            </v-icon>
            {{ local.bankruptcy.subRequests.requestReasonsWarning }}
          </span>

          <template v-if="formModel.reasons.length > 0">
            <naj-box
              v-for="(requestReason, index) in formModel.reasons"
              :key="index"
              :title="local.bankruptcy.subRequests.reasonText[index]"
            >
              <v-row>
                <v-col cols="6">
                  <template v-if="requestReason.isDraft">
                    <naj-input
                      :type-id="formFieldType.textarea"
                      :label="local.bankruptcy.subRequests.reason"
                      :value.sync="requestReasonInput"
                      :counter="256"
                    ></naj-input>
                  </template>

                  <span v-else>
                    <label class="request-reason-label"> {{ local.bankruptcy.subRequests.reason
                    }}</label>
                    <div>
                      <span class="request-reason-text">
                        {{ requestReason.reasonText }}
                      </span>
                    </div>
                  </span>
                </v-col>

                <v-col
                  class="text-center"
                  cols="4"
                >
                  <template v-if="requestType.showRequestReasonAttachment">
                    <label class="request-reason-label">{{ local.bankruptcy.subRequests.attachment
                    }} </label>
                    <div class="row justify-content-center h-75">
                      <div class="align-items-center file-name h-75">
                        <div
                          v-if="requestReason.fileName"
                          class="col-sm-12"
                        >
                          {{ requestReason.fileName }}
                        </div>
                        <div class="col-sm-12">
                          <v-icon
                            v-if="!isViewMode && !requestReason.fileName && isValidForEdit"
                            @click="openRequestReasonAttachmentModal(index)"
                          >
                            mdi-cloud-upload
                          </v-icon>
                          <v-icon
                            v-if="!isViewMode && requestReason.fileName && isValidForEdit"
                            color="red"
                            @click="onShowRemoveRequestReasonAttachmentModal(index)"
                          >
                            mdi-delete
                          </v-icon>
                          <v-btn
                            v-if="requestReason.fileId && requestReason.fileName"
                            icon
                            @click="handleViewAttachment(requestReason)"
                          >
                            <v-icon>
                              mdi-eye
                            </v-icon>
                          </v-btn>
                        </div>
                      </div>
                    </div>
                  </template>
                </v-col>

                <v-col
                  class="d-flex justify-content-end align-items-center"
                  cols="2"
                >
                  <template v-if="requestReason.isDraft">
                    <naj-button
                      :disabled="requestReasonInput.trim().length > 256 || requestReasonInput.trim().length < 1"
                      @click="appendRequestReason(index)"
                    >
                      {{ local.common.save }}
                    </naj-button>
                    <naj-button
                      outlined
                      @click="discardRequestReason(index)"
                    >
                      {{ local.common.cancel }}
                    </naj-button>
                  </template>
                  <template v-else>
                    <v-btn
                      v-if="!isViewMode && !requestReason.isDraft && isValidForEdit"
                      icon
                      @click="
                        activeReason = index;
                        showDeleteReasonConfirmationModal = true;"
                    >
                      <v-icon color="red">
                        mdi-delete
                      </v-icon>
                    </v-btn>
                  </template>
                </v-col>
              </v-row>
            </naj-box>
          </template>
          <v-row>
            <v-col
              v-if="!isViewMode && formModel.reasons.length < 5"
              cols="1"
              class="mb-6"
            >
              <naj-button
                :disabled="isDraftExist || !isValidForEdit"
                icon="mdi-plus"
                @click="handleAddNewReason"
              >
              </naj-button>
            </v-col>
          </v-row>
        </div>

        <naj-confirmation
          :show-modal="showDeleteReasonConfirmationModal"
          :title="local.bankruptcy.subRequests.reasonModal.confirmTitle"
          :message="local.bankruptcy.subRequests.reasonModal.message"
          :ok-btn-label="local.bankruptcy.subRequests.reasonModal.yes"
          :close-btn-label="local.bankruptcy.subRequests.reasonModal.no"
          @ok="() => {
            showDeleteReasonConfirmationModal = false;
            handleRemoveReason();
          }"
          @cancel="showDeleteReasonConfirmationModal = false"
        ></naj-confirmation>

        <div
          v-if="requestType.showAttachmentSection"
          class="px-3 content-wrapper"
        >
          <h3 class="d-inline-block primary--text font-weight-bold col col-2 mb-4">
            {{ local.attachments.title }}
          </h3>
          <template v-if="formModel.attachments.length > 0">
            <naj-box
              v-for="(file, index) in formModel.attachments"
              :key="index"
              :title="(attachmentTypes.find(i => i.id == file.typeId) || {}).name"
            >
              <v-row>
                <v-col cols="10">
                  <label class="request-reason-label"> {{ local.bankruptcy.subRequests.attachmentName
                  }}</label>
                  <div>
                    <span class="request-reason-text">
                      {{ file.fileName }}
                    </span>
                  </div>
                </v-col>
                <v-col
                  class="d-flex justify-content-end align-items-center"
                  cols="2"
                >
                  <v-btn
                    icon
                    @click="handleViewAttachment(file)"
                  >
                    <v-icon>
                      mdi-eye
                    </v-icon>
                  </v-btn>

                  <v-btn
                    v-if="!isViewMode"
                    icon
                    @click="activeAttachment = index;
                            deleteModalVisibility = true"
                  >
                    <v-icon color="red">
                      mdi-delete
                    </v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </naj-box>
          </template>
          <template v-else>
            <v-row v-if="isViewMode">
              <v-col>
                <label class="request-reason-label">
                  {{ local.bankruptcy.subRequests.noAttachments }}</label>
              </v-col>
            </v-row>
          </template>
          <v-row>
            <v-col
              v-if="!isViewMode"
              cols="1"
              class="mb-6"
            >
              <naj-button
                icon="mdi-plus"
                @click="showModal"
              >
              </naj-button>
            </v-col>
          </v-row>
        </div>

        <v-row v-if="isNewMode || isEditMode">
          <v-col
            cols="12"
            class="text-left"
          >
            <naj-button
              :disabled="!isValidForEdit"
              @click="validateRelatedRequestThenSubmit"
            >
              {{ local.common.saveAndSend }}
            </naj-button>
            <naj-confirmation
              :show-modal="showSendRequestConfirmationModal"
              :title="local.common.confirmationSendRequest"
              :message="local.bankruptcy.subRequests.sendRequestConfirmationMessage"
              :ok-btn-label="local.common.yes"
              :close-btn-label="local.common.no"
              @ok="onSubmit"
              @cancel="showSendRequestConfirmationModal = false"
            ></naj-confirmation>
          </v-col>
        </v-row>

        <attachment-modal
          ref="attachmentModalComponent"
          :attachment="selectedAttachment"
          :attachment-categories="attachmentTypes"
          :attachments-data="formModel.attachments"
          modal-button-text=""
          :action-text="local.attachments.addToRequest"
          :view-mode="isViewMode"
          accept="image/*,application/pdf"
          :max-file-size="8"
          @onSubmit="submitUploadAttachment"
        ></attachment-modal>

        <naj-confirmation
          :show-modal="deleteModalVisibility"
          color="error"
          :title="local.common.removeConfirmation"
          :message="local.common.removeConfirmationMessage"
          :ok-btn-label="local.common.remove"
          @ok="() => {
            deleteModalVisibility = false;
            handleDeleteAttachment();
          }"
          @cancel="deleteModalVisibility = false"
        ></naj-confirmation>
        <template v-if="showObjectionForm">
          <objection-form
            :sub-request-memos="subRequestMemos"
            :sub-request-object-key="formModel.objectKey"
          ></objection-form>
        </template>
      </v-form>
    </div>

    <naj-confirmation
      :show-modal="showRemoveRequestReasonAttachmentModal"
      color="error"
      :title="local.common.removeConfirmation"
      :message="local.common.removeConfirmationMessage"
      :ok-btn-label="local.common.remove"
      @ok="() => {
        showRemoveRequestReasonAttachmentModal = false;
        removeRequestReasonAttachment();
      }"
      @cancel="showRemoveRequestReasonAttachmentModal = false"
    ></naj-confirmation>

    <request-reason-modal
      :modal-visibility="showRequestReasonAttachmentModal"
      :max-file-size="8"
      @addRequestReasonAttachment="addRequestReasonAttachment"
      @onClose="hideRequestReasonAttachmentModal"
    >
    </request-reason-modal>

    <render-attachment-modal
      :attachment-file="selectedFile"
      :modal-visibility="showViewAttachmentModal"
      @modalClose="hideViewAttachmentModal"
    >
    </render-attachment-modal>

    <naj-confirmation
      :show-modal="showInformationModal"
      :max-width="750"
      :is-persistent="true"
      :title="local.bankruptcy.subRequests.successAlertMessage"
      :close-btn-label="local.common.close"
      @cancel="closeInformationModal"
    >
      <template slot="message-content">
        <v-row>
          <v-col>
            <naj-alert type="success">
              <template slot="content">
                {{ local.bankruptcy.subRequests.requestSendSuccessfully }}، {{
                  local.bankruptcy.subRequests.requestCode }} {{ requestCodeResult }}
              </template>
            </naj-alert>
          </v-col>
        </v-row>
      </template>
    </naj-confirmation>

    <naj-confirmation
      :show-modal="showValidationSummaryModal"
      :max-width="1000"
      :is-persistent="true"
      :title="local.bankruptcy.subRequests.validationSummaryTitle"
      :close-btn-label="local.common.close"
      @cancel="() => {
        showValidationSummaryModal = false;
        validationSummaryText = '';
      }"
    >
      <template slot="message-content">
        <v-row>
          <v-col>
            <naj-alert type="error">
              <template slot="content">
                <div v-html="validationSummaryText" />
              </template>
            </naj-alert>
          </v-col>
        </v-row>
      </template>
    </naj-confirmation>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
import { mode } from '@/helpers/enum';
import { resetScroll, uuidGenerator } from '@/helpers/utils';
import { fileType, subRequestActionType, legalCapacitiesEnum } from '@/modules/bankruptcy/helpers/enum';
import AttachmentModal from '@/components/shared/attachment-modal/index';
import RequestReasonModal from '@/components/shared/request-reason-modal/index';
import RenderAttachmentModal from '@/components/shared/attachment-modal/render-attachment-modal';
import SubRequestApplicant from './sub-request-applicant.vue';
import subRequestApplicantOnlyName from './sub-request-applicant-only-name.vue';
import OrganizationSubRequestApplicant from './organization-sub-request-applicant.vue';
import OrganizationSubRequestApplicantOnlyName from './organization-sub-request-applicant-only-name.vue';
import ObjectionForm from './objection-form.vue';

const { mapActions: mapBankruptcyActions } = createNamespacedHelpers('BankruptcyModule');
const { mapActions: mapCasesActions } = createNamespacedHelpers('CasesModule');

export default {
  name: 'SubRequestInfo',
  components: {
    AttachmentModal,
    RequestReasonModal,
    RenderAttachmentModal,
    SubRequestApplicant,
    subRequestApplicantOnlyName,
    OrganizationSubRequestApplicant,
    OrganizationSubRequestApplicantOnlyName,
    ObjectionForm,
  },
  props: {
    formModel: {
      type: Object,
      required: true,
    },
    requestType: {
      type: Object,
      required: true,
    },
    requestCustomData: {
      type: Object,
      default: null,
    },
    isNewMode: {
      type: Boolean,
      default: false,
    },
    isEditMode: {
      type: Boolean,
      default: false,
    },
    isViewMode: {
      type: Boolean,
      default: false,
    },
    isInternal: {
      type: Boolean,
      default: false,
    },
    isOrganizationUser: {
      type: Boolean,
      default: false,
    },
    isValidForEdit: {
      type: Boolean,
      default: false,
    },
    attachmentTypes: {
      type: Array,
      default: () => [],
    },
    showObjectionForm: {
      type: Boolean,
      default: false,
    },
    subRequestMemos: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      mode,
      fileType,
      subRequestActionType,
      requestReasonInput: '',
      activeReason: null,
      selectedAttachment: null,
      deleteModalVisibility: false,
      activeAttachment: null,
      showRequestReasonAttachmentModal: false,
      showRemoveRequestReasonAttachmentModal: false,
      showInformationModal: false,
      requestCodeResult: '',
      showSendRequestConfirmationModal: false,
      showValidationSummaryModal: false,
      validationSummaryText: '',
      showViewAttachmentModal: false,
      selectedFile: {},
      showDeleteReasonConfirmationModal: false,
    };
  },
  computed: {
    local() {
      return this.$root?.$options?.local || this.$parent?.local || {};
    },
    isDraftExist() {
      return (this.formModel.reasons || []).some(a => a.isDraft);
    },
    renderOrganizationApplicantDetails() {
      if (this.isNewMode || this.isEditMode) return this.isOrganizationUser;
      return this.formModel?.requestApplicant?.relatedFirmId;
    },
  },
  methods: {
    ...mapBankruptcyActions([
      'validateRelatedRequest',
      'saveRelatedRequest',
      'updateRelatedRequest',
    ]),
    ...mapCasesActions([
      'uploadAttachment',
    ]),

    // --- reasons
    handleAddNewReason() {
      this.formModel.reasons.push({
        reasonText: null,
        isDraft: true,
      });
    },
    appendRequestReason(index) {
      const duplicateReasonExists = this.formModel.reasons.some(r => r.reasonText == this.requestReasonInput);
      if (duplicateReasonExists) {
        this.toaster.error(this.local.caseRelatedRequest.canNotAddDuplicateReason);
        return;
      }
      this.formModel.reasons[index].reasonText = this.requestReasonInput;
      this.formModel.reasons[index].isDraft = false;
      this.resetRequestReasonFields();
    },
    discardRequestReason(index) {
      this.formModel.reasons.splice(index, 1);
      this.resetRequestReasonFields();
    },
    resetRequestReasonFields() {
      this.requestReasonInput = '';
    },
    handleRemoveReason(index = this.activeReason) {
      this.formModel.reasons.splice(index, 1);
    },
    // --- attachments
    showModal(id) {
      this.$refs.attachmentModalComponent.showModal(id);
    },
    attachmentSelected(attachment) {
      this.selectedAttachment = attachment;
      this.$refs.attachmentModalComponent && this.$refs.attachmentModalComponent.showModal();
    },
    submitUploadAttachment({ attachment }) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const b64 = reader.result.replace(/^data:.+;base64,/, '');
        this.uploadAttachment({
          classification: 0,
          documentMetadata: {
            caseId: 0,
            requestCode: 0,
            requestId: 0,
            category: attachment.category,
            fileCategory: attachment.category,
          },
          fileCategory: attachment.category,
          extension: attachment.extension,
          base64FileContent: b64,
        })
          .then(({ data }) => {
            this.formModel.attachments.push({
              fileName: attachment.name,
              extension: attachment.extension,
              fileId: data,
              contentType: attachment.fileObject.type,
              typeId: attachment.category,
              fileTypeId: attachment.fileType,
            });
            this.$refs.attachmentModalComponent.closeModal();
          })
          .catch(err => this.toaster?.error?.(err.message));
      };
      reader.readAsDataURL(attachment.fileObject);
    },
    handleViewAttachment(file) {
      this.selectedFile = {
        name: file.fileName,
        isImage: file.fileTypeId == this.fileType.img,
        sharePointId: file.fileId,
      };
      this.showViewAttachmentModal = true;
    },
    handleDeleteAttachment(index = this.activeAttachment) {
      this.formModel.attachments.splice(index, 1);
    },
    addRequestReasonAttachment(file) {
      this.formModel.reasons[this.activeReason].fileName = file.sharePointFileName;
      this.formModel.reasons[this.activeReason].fileId = file.sharePointId;
      this.formModel.reasons[this.activeReason].fileType = file.fileType;
    },
    onShowRemoveRequestReasonAttachmentModal(index) {
      this.activeReason = index;
      this.showRemoveRequestReasonAttachmentModal = true;
    },
    removeRequestReasonAttachment() {
      this.$set(this.formModel.reasons[this.activeReason], 'fileName', null);
      this.$set(this.formModel.reasons[this.activeReason], 'fileId', null);
      this.$set(this.formModel.reasons[this.activeReason], 'fileType', null);
    },
    editRequestReason(index) {
      this.activeReason = index;
      this.$set(this.formModel.reasons[index], 'isDraft', true);
      this.requestReasonInput = this.formModel.reasons[index].reasonText;
    },
    openRequestReasonAttachmentModal(index) {
      this.activeReason = index;
      this.showRequestReasonAttachmentModal = true;
    },
    hideRequestReasonAttachmentModal() {
      this.activeReason = null;
      this.showRequestReasonAttachmentModal = false;
    },
    hideViewAttachmentModal() {
      this.showViewAttachmentModal = false;
    },

    // --- submit
    validateRelatedRequestThenSubmit() {
      this.$refs.requestFormRef.$validator.validateAll()
        .then((valid) => {
          if (valid) {
            this.loading = true;
            const payload = {
              objectKey: this.formModel.objectKey || uuidGenerator(),
              data: {
                ...this.formModel,
                requestType: this.requestType,
              },
            };
            this.validateRelatedRequest(payload)
              .then(() => {
                this.showSendRequestConfirmationModal = true;
              })
              .catch(err => this.toaster.error(err))
              .finally(() => (this.loading = false));
          } else {
            resetScroll();
          }
        });
    },
    onSubmit() {
      this.$set(this.formModel, 'subRequestTypeId', this.requestType.id);
      const payload = {
        objectKey: this.formModel.mainRequest.objectKey,
        data: { ...this.formModel },
      };
      if (this.isNewMode) {
        this.saveRelatedRequest(payload)
          .then((result) => {
            this.showSendRequestConfirmationModal = false;
            this.requestCodeResult = result.data.requestCode;
            this.showInformationModal = true;
          })
          .catch((err) => {
            if (err.handled) {
              this.showSendRequestConfirmationModal = false;
              this.showValidationSummaryModal = true;
              this.validationSummaryText = err.message;
            } else {
              this.toaster.error(err.message);
            }
          })
          .finally(() => (this.loading = false));
      }
      else if (this.isEditMode) {
        this.$set(payload.data, 'actionId', this.subRequestActionType.updateSubRequest);
        this.updateRelatedRequest(payload)
          .then((res) => {
            this.showSendRequestConfirmationModal = false;
            this.requestCodeResult = res.data.requestCode;
            this.showInformationModal = true;
          })
          .catch((err) => {
            if (err.handled) {
              this.showSendRequestConfirmationModal = false;
              this.showValidationSummaryModal = true;
              this.validationSummaryText = err.message;
            } else {
              this.toaster.error(err.message);
            }
          })
          .finally(() => (this.loading = false));
      }
    },
    closeInformationModal() {
      this.$router.push({ path: '/bankruptcy' });
      this.showInformationModal = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.request-reasons-warning {
  font-size: 16px;
  color: #faad14;
}

.request-reason-label {
  font-size: 20px;
}

.request-reason-text {
  font-size: 15px;
  color: #484952a0;
}

.content-wrapper {
  border: 1px solid #e4e5e6 !important;
  margin-bottom: 25px;
}

.file-name {
  font-size: 18px;
}

.file-upload-icon {
  cursor: pointer;
}
</style>